import { React, useEffect} from 'react';
import { useLocation, Link } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import "./index.scss"

import cybermindrLogo from "../../../assets/images/common/cybermindr_logo.svg";

import { sideNavCustomersIcon, sideNavOrganizationIcon, sideNavDomainIcon, sideNavScanInfoIcon, sideNavUsersIcon, sideNavMonitorIcon, sideNavScanHistory, sideNavScanQueueIcon } from "../../../utils/icons";

import LanguageSwitcher from '../../../components/LanguageSwitcher';
import SideNavProfile from "../SideNavProfile";

import { getloggedInUserType } from "../../../utils/util";

const SideNav = () => {

    const { t } = useTranslation();

    const location = useLocation();

    //destructuring pathname from location
    const { pathname } = location;

    //Javascript split method to get the name of the path in array
    const splitLocation = pathname.split("/");

    const queryParams = new URLSearchParams(location.search);

    const customerId = queryParams.get('customer');
    const organizationId = queryParams.get('organization');
    const domainId = queryParams.get('domain');
    const scanId = queryParams.get('scanId');

    useEffect(()=>{
        if(splitLocation[1] === "scan-info") {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
    },[splitLocation])

    return (
        <div className="side-nav-container pt-2">
            <div className="main-logo-container text-center">
                <img src={cybermindrLogo} alt="logo" />
            </div>
            <div className="side-nav-list">
                <ul type="none">
                    <li className={splitLocation[1] === "scan-info" ? "active" : ""}>                        
                        <Link to={splitLocation[1] === "scan-info" ? `/scan-info/exposure/dashboard?customer=${customerId}&organization=${organizationId}&domain=${domainId}&scanId=${scanId}` : "/scan-info/exposure/dashboard?customer=all&organization=all&domain=all&scanId=null"}>
                            {sideNavScanInfoIcon()}
                            <p>{t("sideNav.nav3")}</p>
                        </Link>
                    </li>
                    {getloggedInUserType() === "internal" && <li className={splitLocation[1] === "customers" ? "active" : ""}>                        
                        <Link to="/customers">
                            {sideNavCustomersIcon()}
                        <p>{t("sideNav.nav7")}</p></Link>
                    </li>}
                    <li className={splitLocation[1] === "organization" || splitLocation[2] === "organization" ? "active" : ""}>                        
                        <Link to="/organization">
                            {sideNavOrganizationIcon()}
                            <p>{t("sideNav.nav1")}</p>
                        </Link>
                    </li>
                    <li className={splitLocation[1] === "domain" ? "active" : ""}>                        
                        <Link to="/domain">
                            {sideNavDomainIcon()}
                            <p>{t("sideNav.nav2")}</p>
                        </Link>
                    </li>                    
                    <li className={splitLocation[1] === "users" ? "active" : ""}>                        
                        <Link to="/users">
                            {sideNavUsersIcon()}
                            <p>{t("sideNav.nav4")}</p>
                        </Link>
                    </li>
                    <li className={splitLocation[1] === "monitor" ? "active" : ""}>                        
                        <Link to="/monitor">
                            {sideNavMonitorIcon()}
                            <p>{t("sideNav.nav5")}</p>
                        </Link>
                    </li>
                    <li className={splitLocation[1] === "scan-history" ? "active" : ""}>                        
                        <Link to="/scan-history">
                            {sideNavScanHistory()}
                            <p>Scan History</p>
                        </Link>
                    </li>
                    <li className={splitLocation[1] === "scan-queue" ? "active" : ""}>                        
                        <Link to="/scan-queue">
                            {sideNavScanQueueIcon()}
                            <p>{t("sideNav.nav6")}</p>
                        </Link>
                    </li>
                </ul>
                <div className="bottom-nav-list mt-5">
                    <LanguageSwitcher />
                    <SideNavProfile />
                </div>
            </div>
        </div>
    )
}

export default SideNav;